/**
 * "Where should we send it?" (owner, 2026-11-01: asked before the build, optional, with Skip). The address
 * a signed-out visitor gives on the last question screen, kept for this tab until the build is under way,
 * when Building sends the ready link to it by itself (screens/new/Building.tsx) — the same email as
 * "Email me when it's ready", asked earlier, while they are still answering.
 */
const KEY = 'saddle.ready.early';

export const EMAIL_SHAPE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function keepEarlyEmail(email: string): void {
  try {
    sessionStorage.setItem(KEY, email);
  } catch {
    /* asked again on the building screen, as before */
  }
}

export function earlyEmail(): string | null {
  try {
    const kept = sessionStorage.getItem(KEY);
    return kept && EMAIL_SHAPE.test(kept) ? kept : null;
  } catch {
    return null;
  }
}

export function forgetEarlyEmail(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* nothing kept */
  }
}
